import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getInboxEncashmentRequest = createAsyncThunk('inboxEncashment/getRequest', async (data) => {
    try {
        const response = await axios.post('/EncashmentRequest/get-request', data, {
            headers: { 'Content-Type': 'application/json' }
        });

        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateInboxEncashmentChangeRemarks = createAsyncThunk('inboxEncashment/updateRemarks', async (data) => {
    try {
        const response = await axios.put('/EncashmentRequest/request-status/' + data?.id, data?.data, {
            headers: { 'Content-Type': 'application/json' }
        });

        toast.success(response?.data?.message || 'Status updated successfully.');
        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

const inboxEncashmentSlice = createSlice({
    name: 'inboxEncashment',
    initialState: {
        encashment: []
    },
    reducers: {
        removeInboxEncashment: (state) => {
            state.encashment = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInboxEncashmentRequest.fulfilled, (state, action) => {
            state.encashment = action?.payload;
        });
    }
});

export const { removeInboxEncashment } = inboxEncashmentSlice.actions;
export default inboxEncashmentSlice.reducer;
